<!--
MENU ITEM BASE COMPONENT:
This component contains all menu item components recursively.
Extend this component to change login template, customize functions and add styles.

PROPS:
- action:       Define menu code where navigate to (default: action)
- itemClass:    Define menu item class (default: menu-item). This is important to define dropdown closing
- item:         Json object from menu Json structure
- curPage:      Current selected page to define if menu item is active
-->

<template>

    <!--MENU ITEM-->
    <li class="menu-item" ref="menuitem" v-bind:class="{ 'active': item.cod && curPage.indexOf(item.cod) > -1 }">

        <!--MENU ITEM TEXT-->
        <a @click="select(item, item.cod)" v-bind:style="{ cursor: 'pointer'}">
            <span v-text="_trans(item.des)"></span>
            <span v-if="item.data" class="arrow" v-bind:class="{ 'dropdown-open': open, 'dropdown-close': !open }"></span>
        </a>

        <!--MENU DROPDOWN-->
        <ul class="dropdown" v-if="(item.data  && item.data.length > 0) && open">

            <!--RECURSIVE MENU ITEMS-->
            <d-menuitem v-for="(item, i) in item.data" :key="i" :item="item" @select="select" :cur-page="curPage"></d-menuitem>
        </ul>
    </li>
</template>

<script>
import { Dau, bus } from "@store/dau"

import dMenuitem from "@base/dmenuItem.vue";

export default {
    name: 'dMenuitem',
    components: {
        dMenuitem
    },
    props: {
        action: { type: String, default: 'action'},
        itemClass: { type: String, default: 'menu-item' },
        curPage: String,
        item: {
            type: Object,
            default() {
                return { des: '**no description**'};
            }
        }
    },
    data() {
        return {
            open: false
        }
    },
    computed: {

    },
    created() {
        document.addEventListener('click',this.onclick);
        document.addEventListener('touchstart',this.onclick);
    },
    mounted() {
        // Always open if this element isn't first of menu item tree
        if(this.$refs && this.$refs.menuitem && this.isMenuItem(this.$refs.menuitem.parentElement))
            this.open = true;
    },
    beforeDestroy() {
        document.removeEventListener('click',this.onclick);
        document.removeEventListener('touchstart',this.onclick);
    },
    methods: {
        onclick(e) {
            // Accept click only from current element
            if(this.$refs && this.$refs.menuitem && this.$refs.menuitem === this.isMenuItem(e.srcElement)){
                // Do open only if this element is first of menu item tree
                if(this.$refs && this.$refs.menuitem && !this.isMenuItem(this.$refs.menuitem.parentElement)){
                    // Check if click is referred to a menu item
                    if (this.isMenuItem(e.srcElement)) {
                        this.toggleSubmenu();
                        this.$forceUpdate();
                    }
                    else {
                        if (this.open) {
                            this.closeSubmenu();
                            this.$forceUpdate();
                        }
                    }
                }
            }
            else if(this.open) {
                this.closeSubmenu();
                this.$forceUpdate();
            }
        },
        /** Check recursively if element is child of a menu item
         * @param el
         * @returns {Boolean|Element} if element is a child of menu item return that element, otherwise return false
         */
        isMenuItem(el){
            if(!el)
                return false;

            if(el.nodeName && el.nodeName.toLowerCase() === 'html'){
                return false;
            }

            if(el.className && el.className.indexOf && el.className.indexOf(this.itemClass) > -1) {
                return el;
            }
            else {
                return this.isMenuItem(el.parentElement);
            }
        },
        toggleSubmenu() {
            this.open = !this.open;
            this.$forceUpdate();
        },
        closeSubmenu() {
            this.open = false;
        },
        select(item) {
            if (item[this.action])
                this.$emit("select",item);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/_eng/globals/_dmenuItem.vue